export const arKeyFeatures = [
  {
    id: 1,
    num: "01",
    title: "Intuitive User Interface",
    description:
      "A seamless design that allows users to search, book, and manage properties with ease.",
    img: require("../../../image/Airbnb/key-img-one.webp"),
  },
  {
    id: 2,
    num: "02",
    title: " Advanced Property Search & Filters",
    description:
      "Enables guests to find accommodations based on location, price, amenities, ratings, and more.",
    img: require("../../../image/Airbnb/key-img-two.webp"),
  },
  {
    id: 3,
    num: "03",
    title: "Multi-Vendor & Multi-Listing Support",
    description:
      "Allows multiple hosts to register, list properties, and manage bookings independently.",
    img: require("../../../image/Airbnb/key-img-three.webp"),
  },
  {
    id: 4,
    num: "04",
    title: "Secure Payment Integration",
    description:
      "Supports multiple payment gateways, including credit/debit cards, PayPal, and cryptocurrency payments.",
    img: require("../../../image/Airbnb/key-img-four.webp"),
  },
  {
    id: 5,
    num: "05",
    title: "Booking & Reservation Management",
    description:
      "Ensures a streamlined booking process with instant confirmations and automated notifications.",
    img: require("../../../image/Airbnb/key-img-five.webp"),
  },
  {
    id: 6,
    num: "06",
    title: "Ratings & Reviews",
    description:
      "Guests can rate their stays and leave reviews, enhancing trust and credibility.",
    img: require("../../../image/Airbnb/key-img-six.webp"),
  },
  {
    id: 7,
    num: "07",
    title: "Messaging System",
    description:
      "Enables direct communication between guests and hosts for a smooth booking experience.",
    img: require("../../../image/Airbnb/key-img-seven.webp"),
  },
  {
    id: 8,
    num: "08",
    title: "AI-Powered Property Recommendations",
    description:
      "Uses machine learning to suggest properties based on user behavior and preferences.",
    img: require("../../../image/Airbnb/key-img-eight.webp"),
  },
  {
    id: 9,
    num: "09",
    title: "Mobile App Compatibility",
    description:
      "A fully responsive mobile application to facilitate on-the-go bookings.",
    img: require("../../../image/Airbnb/key-img-nine.webp"),
  },
  {
    id: 10,
    num: "10",
    title: "Admin Dashboard",
    description:
      "A comprehensive backend for managing bookings, users, payments, and site operations.",
    img: require("../../../image/Airbnb/key-img-ten.webp"),
  },
];

export const arMarketData = [
  {
    id: 1,
    title: "SEO Optimization",
    content:
      "Optimize your platform for search engines to drive organic traffic. Optimize for local search queries, as travelers often search for accommodations in specific cities or regions.",
    rdBtn: "Read more",
  },
  {
    id: 2,
    title: "Paid Advertising Campaigns",
    content:
      "Use platforms like Google Ads, Facebook Ads, and Instagram to target users actively looking for vacation rentals. Leverage highly targeted ad campaigns to attract hosts and guests.",
    rdBtn: "Read more",
  },
  {
    id: 3,
    title: "Social Media Marketing",
    content:
      "Social media platforms are excellent for driving engagement. Create compelling posts, run contests, and partner with influencers to promote your Airbnb clone.",
    rdBtn: "Read more",
  },
  {
    id: 4,
    title: "Partnerships with Property Owners",
    content:
      "Partnering with local property owners or travel bloggers can help drive traffic to your platform. Offering incentives such as discounts for early users can also generate buzz.",
    rdBtn: "Read more",
  },
];
